import { createBuilderModule } from '../../../builder';
import { backgroundColors } from '../../Section/background';
import { SignUpCtaSection } from './SignUpCtaSection';

export default createBuilderModule(SignUpCtaSection, {
  name: 'SignUpCtaSection',
  image: 'https://cdn.zappy.app/2d64dcac2ba7f01bbf4e2cbb38f0d652.png',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      defaultValue: 'Get started for free',
    },
    {
      name: 'subheading',
      type: 'string',
      defaultValue:
        'You can’t add more hours to the day. Zapier is the next best thing.',
    },
    {
      name: 'background',
      type: 'string',
      enum: ['Lava40Dotty', 'Sun60Dotty', ...Object.values(backgroundColors)],
      defaultValue: 'Lava40Dotty',
    },
    {
      name: 'googleSSOEnabled',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'facebookSSOEnabled',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'microsoftSSOEnabled',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'hideFieldsUntilFocus',
      type: 'boolean',
      defaultValue: true,
    },
  ],
});
